module.exports = __webpack_public_path__ + "img/shutterstock_1271305915_1000x667.8dceb3e2.jpg";